import { useMemo, useState } from "react";
import { motion } from "framer-motion";
import BeforeAfterSlider from "@/components/BeforeAfterSlider";

export default function GallerySection({ items }) {
  const [filter, setFilter] = useState("all");
  const categories = useMemo(() => ["all", ...new Set(items.map((i) => i.service))], [items]);
  const shown = filter === "all" ? items : items.filter((i) => i.service === filter);

  return (
    <section id="gallery" className="bg-[#0b1322] text-[#f0f4f8] py-24 md:py-32 border-b border-[#1e9bff]/15" data-testid="gallery-section">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div>
            <span className="text-xs font-mono-lbl uppercase tracking-[0.2em] text-[#1e9bff] block mb-2">Transformations</span>
            <h2 className="font-display uppercase text-white text-[clamp(32px,4vw,52px)] leading-none">
              Before &amp; After Results
            </h2>
          </div>
          <div className="flex flex-wrap gap-2 text-xs font-mono-lbl uppercase">
            {categories.map((c) => (
              <button
                key={c}
                data-testid={`gallery-filter-${c}`}
                onClick={() => setFilter(c)}
                className={
                  filter === c
                    ? "px-3 py-1.5 rounded-full bg-[#1e9bff] text-black font-bold transition-colors"
                    : "px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-[#93b4d4] hover:border-[#1e9bff]/50 hover:text-white transition-colors"
                }
              >
                {c === "all" ? "All" : c.charAt(0).toUpperCase() + c.slice(1)}
              </button>
            ))}
          </div>
        </div>

        {shown.length === 0 ? (
          <p className="text-sm text-[#93b4d4]" data-testid="gallery-empty">No projects in this category yet — check back soon.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {shown.map((item, i) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}
              >
                <BeforeAfterSlider item={item} />
              </motion.div>
            ))}
          </div>
        )}
        <p className="text-[11px] font-mono-lbl text-[#627d98] mt-6" data-testid="gallery-sample-note">
          Drag the handle to compare. Sample images shown until project photos from across South Yorkshire are added.
        </p>
      </div>
    </section>
  );
}
